import React, { useState, useEffect } from "react";
import _ from "lodash";
import { useForm } from "react-hook-form";
import ReactPlayer from "react-player";
import FeedLogo from "./component/FeedLogo";
import FeedButton from "./component/FeedButton";
import {
  FlashMessage,
  Button,
  ErrorTextHelper,
  RichTextEditor,
} from "../../../components/common";
import cameraIcon from "../../../assets/svg/camera.svg";
import Image from "../../../components/common/Image";
import { stripHTMLTags } from "../../../utils/helper";
import useSessionUser from "../../../hooks/useSessionUser";
import { POST_MEDIA_UPLOAD_LIMIT } from "../../../utils/appConstants";
import Modal from "../../../components/common/Modal";
import httpRequest from "../../../utils/httpRequest";
import API_URLS from "../../../utils/apiUrls";
import Checkbox from "../../../components/common/Checkbox";
import Slider from "@material-ui/core/Slider";
import {
  CreateOutlined as CreateOutlinedIcon,
  DeleteOutlined as DeleteIcon,
  OutlinedFlagOutlined as OutlinedFlagOutlinedIcon,
  Flare as FlareIcon,
  WorkOutlineOutlined as WorkOutlineOutlinedIcon,
  SentimentSatisfiedOutlined as SentimentSatisfiedOutlinedIcon,
  TouchAppOutlined as TouchAppOutlinedIcon,
  AdjustOutlined as AdjustOutlinedIcon,
  PanToolOutlined as PanToolOutlinedIcon,
  InsertEmoticonOutlined as InsertEmoticonOutlinedIcon,
  SentimentDissatisfiedOutlined as SentimentDissatisfiedOutlinedIcon,
  PhotoFilterOutlined as PhotoFilterOutlinedIcon,
  PeopleOutlineOutlined as PeopleOutlineOutlinedIcon,
  LocalActivityOutlined as LocalActivityOutlinedIcon,
  Cancel as CancelOut,
} from "@material-ui/icons";
import output from "../../../../src/assets/images/output-onlinegiftools.gif";
import ScheduleModel from "../components/ScheduleModel";
import { Tooltip } from "@material-ui/core";
import ScheduleIcon from "@material-ui/icons/Schedule";
import appRoutes from "../../../routes/app.routes";
import { useHistory } from "react-router-dom";

type FormFields = {
  post_media: any;
  post_text: string;
  video_cover: any;
};
interface MediaAsset {
  file: File;
  url: string;
  type: string;
  // For video files
  thumbnails?: string[];
  selectedCover?: string;
}
interface IProps {
  slug?: string;
  showEditButton?: boolean;
  showShareButton?: boolean;
  showDeleteButton?: boolean;
  picturePath?: string;
  isUploading?: boolean;
  loading?: boolean;
}
function FeedPost(props: IProps) {
  // const dispatch = useDispatch();
  const {
    currentUser,
    IS_COMPANY,
    userProfile,
    userFullName,
    currentCompanyName,
    currentCompanyLogo,
    currentCompanySlug,
  } = useSessionUser();

  const postForm = useForm<FormFields>();
  const {
    control,
    formState: { errors },
    handleSubmit,
    watch,
    setValue,
  } = postForm;
  const [uploadImage, setUploadImage] = useState<any>([]);
  const [uploadVideo, setUploadVideo] = useState<any>([]);
  const [uploadAssets, setUploadAssets] = useState<MediaAsset[]>([]);
  const [postTextLength, setPostTextLength] = useState<number>(0);
  const [overflow, setOverflow] = useState(false);
  const [showAIModal, setShowAIModal] = useState<boolean>(false);
  const [specify, setSpecify] = useState<any>("SoundCausal");
  const [questions, setQuestion] = useState<any>([]);
  const [responseAiData, setResponseAiData] = useState<any>("");
  const [hash, setHash] = useState<boolean>(false);
  const [wordsLimit, setWordLimit] = useState<number>(50);
  const [loading, setLoading] = useState<boolean>(false);
  const [AIflag, setAIflag] = useState<boolean>(false);
  const [profileShareModal, setProfileShareModal] = useState(false);
  const [schedule, setSchedule] = useState<string | null>();
  const [coverModalOpen, setCoverModalOpen] = useState(false);
  const [currentVideoIndex, setCurrentVideoIndex] = useState<number | null>(
    null
  );
  const [postLoading, setPostLoading] = useState(false);

  const handleTimeChange = (selectedTime) => {
    setSchedule(selectedTime.value);
  };

  const postProfile = IS_COMPANY ? currentCompanyLogo : userProfile;
  const postProfileName = IS_COMPANY
    ? (currentCompanyName as string)
    : (userFullName as string);

  const postText = watch("post_text", "");

  useEffect(() => {
    const tmpText = stripHTMLTags(postText);
    setPostTextLength(tmpText.length);
  }, [postText]);

  // const generateThumbnails = (videoFile: File) => {
  //   return new Promise<string[]>((resolve, reject) => {
  //     const video = document.createElement("video");
  //     video.src = URL.createObjectURL(videoFile);
  //     video.crossOrigin = "anonymous";
  //     video.muted = true;
  //     video.playsInline = true;
  //     const canvas = document.createElement("canvas");
  //     const ctx = canvas.getContext("2d");
  //     const thumbnails: string[] = [];

  //     video.onloadedmetadata = () => {
  //       const duration = video.duration;
  //       if (duration < 2) {
  //         reject("Video is too short to generate thumbnails.");
  //         return;
  //       }

  //       // Calculate evenly spaced capture times
  //       const count = 6;
  //       const interval = (duration - 2) / count;
  //       const captureTimes = Array.from(
  //         { length: count },
  //         (_, i) => 1 + i * interval
  //       );

  //       let index = 0;
  //       const captureFrame = (time: number) => {
  //         video.currentTime = time;
  //         video.onseeked = () => {
  //           setTimeout(() => {
  //             canvas.width = video.videoWidth;
  //             canvas.height = video.videoHeight;
  //             ctx?.drawImage(video, 0, 0, canvas.width, canvas.height);
  //             thumbnails.push(canvas.toDataURL("image/jpeg"));
  //             index++;
  //             if (index < captureTimes.length) {
  //               captureFrame(captureTimes[index]);
  //             } else {
  //               resolve(thumbnails);
  //             }
  //           }, 200);
  //         };
  //       };
  //       captureFrame(captureTimes[index]);
  //     };
  //     video.onerror = () => reject("Error loading video");
  //   });
  // };

  // Clear form and state
  
  async function generateThumbnails(
    urlOrFile: string | File,
    count = 6,
    maxSizeKB = 15,
    maxWidth = 320
  ): Promise<string[]> {
    const targetBytes = maxSizeKB * 1024;
    const video = document.createElement('video');
    video.crossOrigin = 'anonymous';
    video.preload = 'auto';
    video.src = typeof urlOrFile === 'string'
      ? urlOrFile
      : URL.createObjectURL(urlOrFile);
  
    // wait for metadata / error
    await new Promise<void>((res, rej) => {
      video.addEventListener('loadedmetadata', () => res(), { once: true });
      video.addEventListener('error', e => rej(e), { once: true });
      video.load();
    });
  
    if (video.duration < 2) {
      if (typeof urlOrFile !== 'string') URL.revokeObjectURL(video.src);
      throw new Error('Video too short (must be >2s)');
    }
  
    // evenly-spaced snapshot times (skip first second)
    const interval = (video.duration - 2) / count;
    const captureTimes = Array.from(
      { length: count },
      (_, i) => 1 + i * interval
    );
  
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d')!;
    const thumbs: string[] = [];
  
    // helper: render current frame and produce a JPEG blob @ quality q
    const toJpegBlob = (q: number) => new Promise<Blob>(resolve =>
      canvas.toBlob(b => resolve(b!), 'image/jpeg', q)
    );
  
    // for each timestamp, seek → draw → compress → dataURL
    for (let t of captureTimes) {
      // seek
      await new Promise<void>(res => {
        const onSeek = () => {
          video.removeEventListener('seeked', onSeek);
          res();
        };
        video.addEventListener('seeked', onSeek);
        video.currentTime = t;
      });
  
      // scale to maxWidth
      const scale = Math.min(1, maxWidth / video.videoWidth);
      canvas.width  = Math.floor(video.videoWidth * scale);
      canvas.height = Math.floor(video.videoHeight * scale);
      ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
  
      // binary-search JPEG quality in [0,1] over ~8 iterations
      let low = 0, high = 1;
      let bestBlob = await toJpegBlob(high);
  
      for (let i = 0; i < 8; i++) {
        const mid = (low + high) / 2;
        const blob = await toJpegBlob(mid);
        if (blob.size > targetBytes) {
          high = mid;
        } else {
          low = mid;
          bestBlob = blob;
        }
      }
  
      // if still too big, downscale dimensions incrementally
      if (bestBlob.size > targetBytes) {
        let currW = canvas.width;
        while (bestBlob.size > targetBytes && currW > 50) {
          currW = Math.floor(currW * 0.8);
          const factor = currW / video.videoWidth;
          canvas.width  = currW;
          canvas.height = Math.floor(video.videoHeight * factor);
          ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
          bestBlob = await toJpegBlob(low);
        }
      }
  
      // blob → dataURL
      const dataUrl = await new Promise<string>((res, rej) => {
        const reader = new FileReader();
        reader.onload  = () => res(reader.result as string);
        reader.onerror = () => rej('FileReader error');
        reader.readAsDataURL(bestBlob);
      });
  
      thumbs.push(dataUrl);
    }
  
    if (typeof urlOrFile !== 'string') URL.revokeObjectURL(video.src);
    return thumbs;
  }

  
  const clearFormAndState = () => {
    postForm.reset();
    setUploadAssets([]);
  };

  // onUploadImage now creates a MediaAsset for each file.
  const onUploadImage = async (e: any) => {
    const files = e.target.files;
    if (!files || files.length === 0) return;

    // Limit to 4 files total
    if (files.length + uploadAssets.length > 4) {
      e.target.value = null;
      FlashMessage(
        `Max ${POST_MEDIA_UPLOAD_LIMIT} files can be uploaded`,
        "error"
      );
      return;
    }

    let newAssets: MediaAsset[] = [];
    for (let i = 0; i < files.length; i++) {
      const file = files[i];
      const fileType = file.type;
      const fileSize = file.size;
      let allowFileSize = fileType === "video/mp4" ? 10485760 : 26214400;
      if (fileSize > allowFileSize) {
        const mb = Math.floor(allowFileSize / 1024 / 1024);
        FlashMessage(`Max ${mb} MB file size allowed`, "error");
        continue; // Skip this file if too big
      }
      const url = URL.createObjectURL(file);
      const asset: MediaAsset = {
        file,
        url,
        type: fileType,
      };
      if (fileType === "video/mp4") {
        // For video files, generate thumbnails
        try {
          const thumbs = await generateThumbnails(file);
          asset.thumbnails = thumbs;
          asset.selectedCover = thumbs[0]; // default cover
        } catch (err) {
          FlashMessage("Error generating video thumbnails", "error");
        }
      }
      newAssets.push(asset);
    }
    // Append new assets to existing ones
    setUploadAssets((prev) => [...prev, ...newAssets]);
  };

  // Open cover selection modal for a specific video asset
  const openCoverModal = (index: number) => {
    setCurrentVideoIndex(index);
    setCoverModalOpen(true);
  };

  // When a cover is selected in the modal, update the corresponding video asset
  const handleCoverSelect = (cover: string) => {
    if (currentVideoIndex !== null) {
      setUploadAssets((prev) =>
        prev.map((asset, idx) =>
          idx === currentVideoIndex ? { ...asset, selectedCover: cover } : asset
        )
      );
    }
    setCoverModalOpen(false);
    setCurrentVideoIndex(null);
  };

  const dataURLtoBlob = (dataURL: string) => {
    const arr = dataURL.split(",");
    const mime = arr[0].match(/:(.*?);/)![1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new Blob([u8arr], { type: mime });
  };

  const onSubmit = async (formData: FormFields) => {
    setPostLoading(true)
    let payload = new FormData();
    if (uploadAssets.length > 0) {
      let i = 1;
      for (const asset of uploadAssets) {
        // Append original media
        payload.append(`post_media_${i}`, asset.file);
        if (asset.type === "video/mp4" && asset.selectedCover) {
          // If the cover is a data URL, convert it to Blob first.
          const coverBlob = asset.selectedCover.startsWith("data:")
            ? dataURLtoBlob(asset.selectedCover)
            : asset.selectedCover;
          payload.append(`cover_media_${i}`, coverBlob);
        }
        i++;
      }
    }
    const postBy = IS_COMPANY ? (currentCompanySlug as string) : "user";
    payload.append("schedule_at", schedule || "");
    payload.append("post_text", formData.post_text || "");
    payload.append("post_by", postBy);
    payload.append("clientType", "web");
    try {
      const data=await httpRequest().post(API_URLS.posts, payload);
          if(data.data.status === 200) {
        setPostLoading(false)
      }
      clearFormAndState();
    } catch (error) {
      setPostLoading(false)
      FlashMessage("There was an error posting your update", "error");
    }finally{
      setPostLoading(false)
    }
  };

  const removeMedia = (i) => {
    if (uploadImage) {
      const images = [...uploadImage];
      const imageObj = [...uploadAssets];
      imageObj.splice(i, 1);
      images.splice(i, 1);
      setUploadImage(images);
      setUploadAssets(imageObj);
    } else if (uploadVideo) {
      const videos = [...uploadVideo];
      videos.splice(i, 1);
      setUploadVideo(videos);
    }
    const removeObj = [...uploadAssets];
    removeObj.splice(i, 1);
    setUploadAssets(removeObj);
  };

  const checkKeyDown = (e) => {
    const keyCode = e.keyCode ? e.keyCode : e.which;
    if (keyCode === 13 && !e.shiftKey) {
      e.preventDefault();
    }
  };

  const invokeBedRock = async () => {
    setLoading(true);
    try {
      if (questions.length > 0) {
        const specification = specify;
        const question = questions;
        const payload = {
          question: question,
          specification: specification,
          hash: hash,
          words: wordsLimit,
        };
        const response = await httpRequest().post(
          API_URLS.invokeAwsBedRock,
          payload
        );
        setResponseAiData(response.data.data);
      } else {
        FlashMessage("Please Enter Question", "error");
      }
    } catch (error) {
      FlashMessage(error, "error");
    } finally {
      setLoading(false);
    }
  };

  const handleChange = () => {
    setHash(!!!hash);
  };

  const handleClear = () => {
    setQuestion("");
    setResponseAiData("");
    setSpecify("SoundCausal");
    setHash(false);
    setWordLimit(50);
  };

  const postIncidenceReports = async () => {
    try {
      if (responseAiData) {
        const specification = specify;
        const question = questions;
        const payload = {
          question: question,
          outputText: responseAiData,
          specification: specification,
          hash: hash,
          words: wordsLimit,
        };
        await httpRequest().post(API_URLS.postIncidenceReports, payload);
        FlashMessage("Incidence Report Generate Successfully", "success");
      }
    } catch (error) {
      FlashMessage(error, "error");
    }
  };
  const history = useHistory();
  const handleArticle = () => {
    history.push(appRoutes.article.path);
  };

  return (
    <>
      {currentUser && (
        <div className="feed-input-wrapper">
          <FeedLogo profileLogo={postProfile} name={postProfileName} />
          <form onSubmit={handleSubmit(onSubmit)} encType="multipart/form-data">
            <div
              className={`post-wrapper wysiwyg-data ${
                overflow ? "no-overflow" : ""
              }`}
            >
              <RichTextEditor
                name="post_text"
                validationObj={errors}
                control={control}
                showError={false}
                setOverflow={setOverflow}
                value={postText}
                rules={{
                  validate: {
                    validLength: (value) => {
                      const tmpText = stripHTMLTags(value || "");
                      return (
                        tmpText.length <= 3000 ||
                        "Can not exceed more then 3000 characters"
                      );
                    },
                  },
                }}
                useMention={true}
                AIflag={AIflag}
              />
            </div>
            {_.get(errors, "post_text.message") && (
              <ErrorTextHelper text={_.get(errors, "post_text.message", "")} />
            )}
            <p>{postTextLength}/3000</p>

            <div className="media-uploaded">
              {uploadAssets.map((asset, i) => (
                <div className="media-src" key={i}>
                  <span className="media-close" onClick={() => removeMedia(i)}>
                    <CancelOut />
                  </span>
                  {asset.type === "video/mp4" ? (
                    <>
                      <ReactPlayer
                        width="100%"
                        height="100%"
                        url={asset.url}
                        playing={false}
                        controls={true}
                      />
                      <span
                        onClick={() => openCoverModal(i)}
                        color="secondary"
                        className="cover-btn"
                      >
                        Edit Cover
                      </span>
                    </>
                  ) : (
                    <Image src={asset.url} alt="media image" />
                  )}
                </div>
              ))}
            </div>
            <div className="feed-button-wrapper">
              <FeedButton
                svg={cameraIcon}
                name="post_media"
                id="create_post"
                type="file"
                form={postForm}
                onUploadImage={onUploadImage}
                value="post_media"
                accept="image/png, image/gif, image/bmp, image/jpeg, video/mp4"
              />

              <ScheduleModel
                open={profileShareModal}
                onClose={() => setProfileShareModal(false)}
                setSchedule={handleTimeChange}
              />
              {/* <FeedButton
                svg={cameraIcon}
                name="video_cover"
                id="video_cover"
                type="file"
                form={postForm}
                onUploadImage={onUploadCover}
                value="video_cover"
                accept="image/png, image/gif, image/bmp, image/jpeg"
              /> */}
              <Tooltip
                title="Schedule for later"
                placement="top"
                arrow
                className="schedule-post"
              >
                <div
                  onClick={() => setProfileShareModal(true)}
                  className="action-item-icon"
                >
                  <ScheduleIcon color="primary" />
                </div>
              </Tooltip>
              <Button
                className="write-ai"
                color="secondary"
                onClick={() => {
                  setAIflag(false);
                  setShowAIModal(true);
                }}
              >
                <CreateOutlinedIcon />
                &nbsp;Write with AI
              </Button>

              {showAIModal && (
                <Modal
                  title={
                    <>
                      {" "}
                      Generate with employ{" "}
                      <span style={{ color: "#F33066" }}>Her</span>&nbsp;AI{" "}
                    </>
                  }
                  className="ai-model"
                  visible={true}
                  onClose={() => {
                    loading ? setShowAIModal(true) : setShowAIModal(false);
                    handleClear();
                  }}
                >
                  <div className="ai-output">
                    {loading ? (
                      <div className="load-image">
                        <Image src={output} />
                      </div>
                    ) : responseAiData ? (
                      <textarea
                        className="response"
                        onChange={(e) => {
                          setResponseAiData(e?.currentTarget?.value || "");
                        }}
                      >
                        {responseAiData}
                      </textarea>
                    ) : (
                      <>
                        <textarea
                          className="ai-question"
                          id="title"
                          maxLength={150}
                          placeholder="Enter a Prompt here"
                          rows={30}
                          cols={30}
                          value={questions}
                          onKeyDown={(e) => checkKeyDown(e)}
                          onChange={(e) => {
                            setQuestion(e?.currentTarget?.value || "");
                          }}
                        />
                      </>
                    )}
                    {!loading && (
                      <div>
                        <DeleteIcon
                          className="delete-icon"
                          onClick={() => setResponseAiData("")}
                        />
                        <OutlinedFlagOutlinedIcon
                          className="flag"
                          onClick={() => postIncidenceReports()}
                        />
                        <Button
                          className="rephrase"
                          color="secondary"
                          onClick={() => invokeBedRock()}
                        >
                          <FlareIcon />
                          &nbsp;GENERATE MAGIC
                        </Button>
                      </div>
                    )}
                  </div>
                  <div className="specification-area">
                    <div className="adjust-tone">Adjust Tone</div>
                    <div className="btn-specification">
                      <Button
                        color={
                          specify === "SoundCausal" ? "primary" : "secondary"
                        }
                        className="specification"
                        type="submit"
                        disabled={loading}
                        onClick={() => setSpecify("SoundCausal")}
                      >
                        <WorkOutlineOutlinedIcon />
                        &nbsp;Sound Causal
                      </Button>
                      <Button
                        color={
                          specify === "SoundProfessional"
                            ? "primary"
                            : "secondary"
                        }
                        className="specification"
                        type="submit"
                        disabled={loading}
                        onClick={() => setSpecify("SoundProfessional")}
                      >
                        <LocalActivityOutlinedIcon />
                        &nbsp;Sound Professional
                      </Button>
                      <Button
                        color={
                          specify === "MakeItFriendly" ? "primary" : "secondary"
                        }
                        className="specification"
                        type="submit"
                        disabled={loading}
                        onClick={() => setSpecify("MakeItFriendly")}
                      >
                        <SentimentSatisfiedOutlinedIcon />
                        &nbsp;Make It Friendly
                      </Button>
                      <Button
                        color={
                          specify === "MakeItDirect" ? "primary" : "secondary"
                        }
                        className="specification"
                        type="submit"
                        disabled={loading}
                        onClick={() => setSpecify("MakeItDirect")}
                      >
                        <AdjustOutlinedIcon /> &nbsp;Make It Direct
                      </Button>
                      <Button
                        color={
                          specify === "MakeItAssertive"
                            ? "primary"
                            : "secondary"
                        }
                        className="specification"
                        type="submit"
                        disabled={loading}
                        onClick={() => setSpecify("MakeItAssertive")}
                      >
                        <TouchAppOutlinedIcon />
                        &nbsp;Make It Assertive
                      </Button>

                      <Button
                        color={
                          specify === "MakeItPersuasive"
                            ? "primary"
                            : "secondary"
                        }
                        className="specification"
                        type="submit"
                        disabled={loading}
                        onClick={() => setSpecify("MakeItPersuasive")}
                      >
                        <AdjustOutlinedIcon /> &nbsp;Make It Persuasive
                      </Button>
                      <Button
                        color={
                          specify === "SoundConfident" ? "primary" : "secondary"
                        }
                        className="specification"
                        type="submit"
                        disabled={loading}
                        onClick={() => setSpecify("SoundConfident")}
                      >
                        <PeopleOutlineOutlinedIcon />
                        &nbsp;Sound Confident
                      </Button>
                      <Button
                        color={
                          specify === "MakeItLuxury" ? "primary" : "secondary"
                        }
                        className="specification"
                        type="submit"
                        disabled={loading}
                        onClick={() => setSpecify("MakeItLuxury")}
                      >
                        <SentimentSatisfiedOutlinedIcon />
                        &nbsp;Make It Luxury
                      </Button>
                      <Button
                        color={
                          specify === "MakeItEmpathetic"
                            ? "primary"
                            : "secondary"
                        }
                        className="specification"
                        type="submit"
                        disabled={loading}
                        onClick={() => setSpecify("MakeItEmpathetic")}
                      >
                        <InsertEmoticonOutlinedIcon />
                        &nbsp;Make It Empathetic
                      </Button>
                      <Button
                        color={
                          specify === "MakeItConstructive"
                            ? "primary"
                            : "secondary"
                        }
                        className="specification"
                        type="submit"
                        disabled={loading}
                        onClick={() => setSpecify("MakeItConstructive")}
                      >
                        <PanToolOutlinedIcon />
                        &nbsp;Make It Constructive
                      </Button>
                      <Button
                        color={
                          specify === "MakeItDiplomatic"
                            ? "primary"
                            : "secondary"
                        }
                        className="specification"
                        type="submit"
                        disabled={loading}
                        onClick={() => setSpecify("MakeItDiplomatic")}
                      >
                        <SentimentDissatisfiedOutlinedIcon />
                        &nbsp;Make It Diplomatic
                      </Button>

                      <Button
                        color={
                          specify === "MakeItInspirational"
                            ? "primary"
                            : "secondary"
                        }
                        className="specification"
                        type="submit"
                        disabled={loading}
                        onClick={() => setSpecify("MakeItInspirational")}
                      >
                        <PhotoFilterOutlinedIcon />
                        &nbsp;Make It Inspirational
                      </Button>
                    </div>
                  </div>
                  <div className="main-hash-range">
                    <div className="hash">
                      <Checkbox
                        name="hash"
                        externalLabel={{ label: "Add Hashtags" }}
                        checked={hash}
                        disabled={loading}
                        onClick={() => {
                          handleChange();
                        }}
                      />
                    </div>
                    <div className="slider">
                      <div className="count-title">Words Count</div>
                      <Slider
                        disabled={loading}
                        defaultValue={50}
                        value={wordsLimit}
                        min={50}
                        max={300}
                        step={10}
                        onChange={(e, words) => setWordLimit(words as number)}
                      />
                      <div className="word-count">({wordsLimit}words)</div>
                    </div>
                  </div>
                  <Button
                    color="primary"
                    className="insert-post"
                    type="submit"
                    disabled={!responseAiData || loading}
                    onClick={() => {
                      setValue("post_text", responseAiData);
                      setAIflag(true);
                      setShowAIModal(false);
                      handleClear();
                    }}
                  >
                    INSERT TO POST
                  </Button>
                </Modal>
              )}
              <Button
                className="submit-btn"
                loading={postLoading}
                disabled={
                  // uploadImage.length > 0 ||
                  uploadAssets.length > 0 || postText.length > 0 ? false : true
                }
                type="submit"
              >
                Post
              </Button>

              <Button
                onClick={() => {
                  handleArticle();
                }}
                color="secondary"
              >
                Write Article ?
              </Button>
            </div>
            {coverModalOpen && currentVideoIndex !== null && (
              <Modal
                title="Select Cover Image"
                visible={coverModalOpen}
                onClose={() => setCoverModalOpen(false)}
                className="post-cover-modal"
              >
                <div className="cover-modal-body">
                  {uploadAssets[currentVideoIndex].thumbnails &&
                  uploadAssets[currentVideoIndex].thumbnails.length > 0 ? (
                    <div className="cover-options-container">
                      {uploadAssets[currentVideoIndex].thumbnails.map(
                        (thumb, idx) => (
                          <img
                            key={idx}
                            src={thumb}
                            alt={`Cover option ${idx + 1}`}
                            onClick={() => handleCoverSelect(thumb)}
                            className={
                              uploadAssets[currentVideoIndex].selectedCover ===
                              thumb
                                ? "cover-option-img selected"
                                : "cover-option-img"
                            }
                          />
                        )
                      )}
                    </div>
                  ) : (
                    <p className="no-cover-text">No cover images available.</p>
                  )}
                </div>
              </Modal>
            )}
          </form>
        </div>
      )}
    </>
  );
}

export default FeedPost;
